import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../utils/analytics';

// Simplified analytics hook
export const useAnalytics = () => {
  const location = useLocation();

  // Initialize analytics on mount
  useEffect(() => {
    analytics.init();
  }, []);

  // Return simplified API
  return {
    trackEvent: () => {},
    trackServiceInteraction: () => {},
    trackAppointmentScheduling: () => {},
    trackContactSubmission: () => {},
    trackResourceDownload: () => {},
    trackExternalLink: () => {},
    trackFunnelStep: () => {},
    trackServiceInterest: () => {},
    trackLeadQuality: () => {},
    addEngagementAction: () => {}
  };
};

// Simplified interaction tracking hook
export const useInteractionTracking = () => {
  return {
    trackButtonClick: () => {},
    trackFormInteraction: () => {},
    trackVideoInteraction: () => {},
    trackPhoneCall: () => {},
    trackEmailClick: () => {}
  };
};

// Simplified A/B testing hook
export const useABTesting = () => {
  return {
    variant: 'A',
    trackConversion: () => {}
  };
};